import React from 'react';

export const FormExtensionContext = React.createContext({
  renderField: null,
  customFieldPropsAreEqual: null,
  customLeafFieldNames: null,
  customContainerChildrenPropsEqual: null,
  customContainerValuesEqual: null,
});

export function renderFields({ fields, values, setFieldValue, touched }) {
  if (typeof fields === 'function') {
    return fields({ values, setFieldValue, touched });
  }

  return fields;
}

export function getNestedValue(obj, path) {
  if (!path || !obj) return undefined;
  return path.split('.').reduce((current, key) => current?.[key], obj);
}

export function fieldValueEqual(a, b) {
  if (a === b) return true;
  if (a == null || b == null) return a === b;
  if (typeof a !== 'object' || typeof b !== 'object') return false;
  const keysA = Object.keys(a);
  const keysB = Object.keys(b);
  if (keysA.length !== keysB.length) return false;
  return keysA.every(key => a[key] === b[key]);
}

/**
 * Returns true if the field should be hidden.
 * `hidden` and `visible` may each be a boolean or a function of values.
 */
export function getIsFieldHidden(field, values) {
  if (field.hidden === false) return false;
  if (field.hidden === true) return true;
  if (typeof field.hidden === 'function') return field.hidden(values);
  if (field.visible === false) return true;
  if (field.visible === true) return false;
  if (typeof field.visible === 'function') return !field.visible(values);
  return false;
}
